import React from 'react';
import styled from 'styled-components';
import { darken } from 'polished';
//
import colors from 'theme/colors';
import Default from 'components/sidebar/deal-management/default';
import Button from 'components/buttons/simple';

const { darkBorder, darkPanelBackground, yellow, labelPlatinum, darkLinksAndButtonsActive } = colors;

const SidebarDealManagement = styled.div({
  minWidth: 250,
  height: 'calc(100vh - 59px)',
  background: darkPanelBackground,
  color: labelPlatinum,
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'flex-start',
  boxShadow:
    '0px 1px 8px rgba(29, 29, 37, 0.2), 0px 3px 4px rgba(29, 29, 37, 0.12), 0px 3px 3px rgba(29, 29, 37, 0.14)',
});

const Content = styled.div`
  overflow-y: scroll;
  overflow-x: hidden;
  width: 250px;
  height: calc(100vh - 125px);
`;

const EvaluateButtonContainer = styled.div`
  background-color: ${darkLinksAndButtonsActive};
  padding: 16px;
`;

const colorDarken = 0.1;

const EvaluateButton = styled(Button)`
  width: 100%;
  background-color: ${yellow};
  color: ${darkBorder};
  :hover {
    background-color: ${darken(colorDarken, yellow)};
  }
`;

interface IDealManagementProps {
  canEvaluateDeal: boolean;
  getDealEvaluation: () => void;
}

export default ({ canEvaluateDeal, getDealEvaluation }: IDealManagementProps) => {
  function getEvaluateButtonAttributes() {
    return {
      disabled: !canEvaluateDeal,
      onClick: getDealEvaluation,
    };
  }

  return (
    <SidebarDealManagement>
      <Content>
        <Default />
      </Content>
      <EvaluateButtonContainer>
        <EvaluateButton {...getEvaluateButtonAttributes()}>Evaluate</EvaluateButton>
      </EvaluateButtonContainer>
    </SidebarDealManagement>
  );
};
